module.exports = __webpack_public_path__ + "static/img/news-bg.ca183ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news-bg.jpg
// module id = NjQj
// module chunks = 78